import {
  Avatar as ChakraAvatar,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from '@chakra-ui/react';
import { Router } from '@ui/config/routes';
import { useAuth } from '@ui/state/auth';
import { menuProps } from '@ui/util/menuProps';
import { Link as RouterLink } from 'react-router';

type AvatarProps = {
  showDisplayName?: boolean;
};

export function Avatar({ showDisplayName = false }: AvatarProps) {
  const { user, logout } = useAuth();

  if (!user) {
    return null;
  }

  const buttonStyles = {
    width: '100%',
    '> span': {
      display: 'flex',
      alignItems: 'center',
      justifyItems: 'center',
      width: '100%',
      gap: 10,
      justifyContent: 'center',
    },
  };

  return (
    <Menu>
      <MenuButton width="100%" css={showDisplayName ? buttonStyles : null}>
        <ChakraAvatar
          name={user?.displayName}
          bgColor="mw.darkBlue"
          textColor="white"
          size="sm"
        />
        <Text
          display={'inline-block'}
          maxWidth={showDisplayName ? 'unset' : 0}
          maxHeight={showDisplayName ? 'unset' : 0}
          opacity={showDisplayName ? 1 : 0}
          whiteSpace="nowrap"
          transition="max-width 160ms linear, max-height 160ms linear, opacity 200ms linear"
          overflow="hidden"
        >
          {user?.displayName}
        </Text>
      </MenuButton>
      <MenuList
        borderRadius={0}
        color={'mw.lightGrey'}
        backgroundColor={'mw.darkGrey'}
        p={'1.5rem'}
        border="none"
      >
        <MenuItem
          as={RouterLink}
          to={Router.path(Router.routes.userProfile)}
          {...menuProps.item}
        >
          Profile
        </MenuItem>
        <MenuItem onClick={() => logout()} {...menuProps.item}>
          Logout
        </MenuItem>
      </MenuList>
    </Menu>
  );
}
